// extracted by mini-css-extract-plugin
export default {"form":"form__qB0CLANCvxraJLxghjyl","title":"title__k835E9ItKZCygJoL1t3D","subtitle":"subtitle__vUYLBFj5GfsDsWxKZdZO"};